import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { ENABLE_ON_MOUSE_DOWN_FOR_FILTER_BUTTONS_250122 } from "@faire/web-api--source/indigofair/settings/ENABLE_ON_MOUSE_DOWN_FOR_FILTER_BUTTONS_250122";

export const useGetSettingEnableOnMouseDownFilters = (): boolean =>
  useSetting(ENABLE_ON_MOUSE_DOWN_FOR_FILTER_BUTTONS_250122, false);

export const useAssignSettingEnableOnMouseDownFilters = () =>
  useAssignSetting(ENABLE_ON_MOUSE_DOWN_FOR_FILTER_BUTTONS_250122);
